/**
 * Pokud ude mít input atribut data-uppercase-input budou se znaky při psaní převádět na uppercase
 * @param {HTMLElement} element
 */
function initUppercaseInput(element) {
	element.querySelectorAll('[data-uppercase-input]').forEach(function (uppercaseInput) {
		uppercaseInput.addEventListener('input', function () {
			let currentValue = uppercaseInput.value;
			uppercaseInput.value = currentValue.toUpperCase();
		});
	});
}

export default function () {
	$.nette.ext('uppercase-input', {
		init: function () {
			initUppercaseInput(document);

			this.ext('snippets', true).after(($el) => {
				if ($el.get(0)) {
					initUppercaseInput($el.get(0));
				}
			});
		}
	});
}
